import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

export default function initParallax() {
	gsap.registerPlugin(ScrollTrigger);
	gsap.registerPlugin(ScrollToPlugin);

	const win = jQuery(window);
	const header = jQuery('#header');
	const mm = gsap.matchMedia();

	jQuery('.parallax-container').each(function() {
		const holder = jQuery(this);
		const topSections = holder.find('.top-sections');
		const introSection = holder.find('.intro-section');
		const introText = holder.find('.intro-text');
		const mainTitles = introText.find('.main-titles');
		const mainTitlesContent = holder.find('.main-titles-content');
		const introTwoColumsText = introText.find('.two-columns-text');
		const textHolder = introText.find('.text-wrapper');
		const infoTextContainer = introText.find('.container');
		const visualBlock = holder.find('.visual-block');
		const contentSection = holder.find('.content-sections');
		const sectionTitles = holder.find('.section-titles');
		const sectionTitlesHolder = sectionTitles.find('.holder');
		const contentBlocks = contentSection.find('.content-section');
		const stepsSection = holder.find('.steps-section');
		const stepsSectionWrapper = stepsSection.find('.section-wrap');
		const stepItems = stepsSection.find('.step-item');
		const promoBtn = holder.find('.promo-box .btn');
		let headerHeight = 0;
		let infoTextHeight = 0;
		let topPartHeight = 0;

		if (mainTitles.length && mainTitlesContent.length) {
			mainTitles.html(mainTitlesContent.html());
		}

		contentBlocks.each((i, item) => {
			const section = jQuery(item);
			const title = section.find('.title-block');

			if (title.length) {
				title.clone().removeClass('d-lg-none').appendTo(sectionTitlesHolder);
			}
		});

		const titles = sectionTitles.find('.title-block');
		const titleRows = titles.find('.row');

		mm.add('(min-width: 1024px)', () => {
			const tl1 = gsap.timeline({
				scrollTrigger: {
					trigger: topSections[0],
					invalidateOnRefresh: true,
					start: () => `top ${headerHeight}`,
					end: 'bottom bottom',
					scrub: true,
					pinSpacing: false
				}
			});

			tl1.fromTo(textHolder, {
				height: 0
			}, {
				height: '100%',
				ease: 'power1.inOut'
			}, 0).fromTo(visualBlock, {
				opacity: 0
			}, {
				opacity: 1,
				ease: 'power1.inOut'
			}, 0);

			const tl2 = gsap.timeline({
				scrollTrigger: {
					trigger: contentSection[0],
					invalidateOnRefresh: true,
					start: 'top bottom',
					end: () => `top ${topPartHeight}`,
					pinSpacing: false,
					scrub: true
				}
			});

			tl2.fromTo(sectionTitlesHolder, {
				height: 0
			}, {
				height: '100%',
				ease: 'power1.inOut'
			});

			contentBlocks.each((i, item) => {
				const tl = gsap.timeline({
					scrollTrigger: {
						trigger: item,
						invalidateOnRefresh: true,
						start: 'top +450',
						end: () => 'top bottom',
						scrub: true
					}
				});

				tl.fromTo(titles.eq(i), {
					opacity: 0
				}, {
					opacity: 1,
					ease: 'power1.inOut'
				});
			});

			const tl3 = gsap.timeline({
				scrollTrigger: {
					trigger: stepsSection[0],
					invalidateOnRefresh: true,
					start: () => `top ${topPartHeight}`,
					end: () => `+=${stepItems.length * 10}`,
					pin: true,
					scrub: true
				}
			});

			stepItems.each((i, item) => {
				tl3.fromTo(item, {
					opacity: 0
				}, {
					opacity: 1,
					ease: 'power1.inOut'
				});
			});

			const tl4 = gsap.timeline({
				scrollTrigger: {
					trigger: stepsSection[0],
					invalidateOnRefresh: true,
					start: '-300 bottom',
					end: () => `top ${topPartHeight}`,
					scrub: true
				}
			});

			tl4.fromTo(stepsSectionWrapper[0], {
				y: -150
			}, {
				y: 0,
				ease: 'power1.inOut'
			});

			ScrollTrigger.create({
				trigger: stepsSection[0],
				start: () => `top ${topPartHeight - 1}`,
				end: 'bottom top',
				onUpdate: (self) => {
					introText.css({
						transform: `translate(0, ${(self.start - self.end) * self.progress.toFixed(3)}px)`
					});
				}
			});

			promoBtn.on('focus', () => {
				gsap.to(window, {
					duration: 1,
					scrollTo: tl1.scrollTrigger.end
				});
			});

			resizeHandler();

			win.on('load resize orientationchange', resizeHandler);
		});

		mm.add('(max-width: 991px)', () => {
			win.off('load resize orientationchange', resizeHandler);
			removeStyles();
		});

		function resizeHandler() {
			removeStyles();

			headerHeight = header.outerHeight();
			infoTextHeight = infoTextContainer.outerHeight();
			topPartHeight = infoTextHeight + headerHeight;

			let maxTitleHeight = 0;

			titles.each((i, elem) => {
				const item = jQuery(elem).find('> .container');
				const height = item.outerHeight();

				if (height > maxTitleHeight) {
					maxTitleHeight = height;
				}
			});

			if (introTwoColumsText.outerHeight() > maxTitleHeight) {
				maxTitleHeight = introTwoColumsText.outerHeight();
			}

			introText.css({
				height: infoTextHeight
			});

			topSections.css({
				height: '200vh'
			});

			introSection.css({
				paddingTop: infoTextHeight
			});

			sectionTitles.css({
				height: maxTitleHeight
			});

			titleRows.css({
				height: maxTitleHeight
			});
		}

		function removeStyles() {
			introText.removeAttr('style');
			topSections.removeAttr('style');
			introSection.removeAttr('style');
			sectionTitles.removeAttr('style');
			titleRows.removeAttr('style');
		}
	});
}
